import AttendanceSerializer from './base';

export default class Threshold extends AttendanceSerializer {}
